import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';

const gamesStatsMapping = {
  mobile: {
    revenue: dbiPageLogMes.companyDetailsGamesStatsMobileRevenue,
    downloads: dbiPageLogMes.companyDetailsGamesStatsMobileDownloads,
  },
  pc: {
    digitalRevenue: dbiPageLogMes.companyDetailsGamesStatsPCDigitalRevenue,
    physicalRevenue: dbiPageLogMes.companyDetailsGamesStatsPCPhysicalRevenue,
    pcu: dbiPageLogMes.companyDetailsGamesStatsPCPCU,
    mau: dbiPageLogMes.companyDetailsGamesStatsPCMAU,
  },
  console: {
    digitalRevenue: dbiPageLogMes.companyDetailsGamesStatsConsoleDigitalRevenue,
    physicalRevenue: dbiPageLogMes.companyDetailsGamesStatsConsolePhysicalRevenue,
    mau: dbiPageLogMes.companyDetailsGamesStatsConsoleMAU,
  },
  gamesOwned: dbiPageLogMes.companyDetailsGamesStatsGamesOwned,
} as any;

export const getGamesStatsPageLogMes = (tab: string, subTab: string) => {
  if (tab === 'gamesOwned') {
    return gamesStatsMapping.gamesOwned;
  }
  return gamesStatsMapping[tab]?.[subTab] || null;
};

export const COMPANY_GAMESTATS_PAGEID = {
  pcu: 'pcu',
  mau: 'mau',
  physicalRevenue: 'physicalRevenue',
  digitalRevenue: 'digitalRevenue',
  revenue: 'revenue',
  downloads: 'downloads'
};
